
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");

@Component
export default class ReportOrdersProgress extends Vue {
	@Prop()
	private tab!: any;
	private loading: boolean = false;
	private startYear: number = moment().year();
	private weeklyOrders: any[] = [];
	private selectableYears: number[] = [];
	private chart: any = null;
	private pagination: any = {
		sortBy: "weekNumber",
		descending: false,
		rowsPerPage: -1,
	};

	private mounted() {
		for (let i = new Date().getFullYear(); i >= 2012; i--) {
			this.selectableYears.push(i);
		}
	}

	@Watch("tab")
	private async loadReports() {
		if (this.tab === 1 && !this.loading && this.weeklyOrders.length <= 0) {
			await this.loadOrderReports();
		}
	}
	@Watch("startYear")
	private async onStartYearChange() {
		if (!this.loading) {
			await this.loadOrderReports();
		}
	}

	private get tableHeaders() {
		return [
			{
				text: "KW",
				align: "left",
				sortable: false,
				value: "weekNumber",
			},
			{
				text: "Zeitraum Start",
				align: "left",
				sortable: false,
				value: "startDate",
			},
			{
				text: "Zeitraum Ende",
				align: "left",
				sortable: false,
				value: "endDate",
			},
			{
				text: this.startYear,
				align: "right",
				sortable: false,
				value: "amountRef",
			},
			{
				text: this.startYear - 1,
				align: "right",
				sortable: false,
				value: "amountComp",
			},
		];
	}

	private get referenceYearData() {
		return this.weeklyOrders.filter((o: any) => moment(o.startDate).year() == this.startYear);
	}
	private get compareYearData() {
		return this.weeklyOrders.filter(
			(o: any) => moment(o.startDate).year() == this.startYear - 1
		);
	}

	private getFormattedDate(date: Date) {
		return moment(date).format("DD.MM.YYYY");
	}
	private getCompareAmount(index: number) {
		if (typeof this.compareYearData[index] === "undefined") {
			return 0;
		} else {
			return this.compareYearData[index].amountTotal;
		}
	}

	private async loadOrderReports() {
		if (this.loading) {
			return;
		}
		try {
			this.loading = true;
			const response = await httpClient().get(
				`Report/GetWeeklyOrderTotalsForYear?year=${this.startYear}`
			);
			this.weeklyOrders = response.data;
			if (this.weeklyOrders.length > 0) {
				this.updateDiagram();
			}
		} catch (err) {
			console.log("Loading evaluation reports failed.");
			console.log(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private updateDiagram() {
		const labels = this.referenceYearData.map(
			(f: any) => `KW${f.weekNumber} - ${moment(f.startDate).format("DD.MM.YYYY")}`
		);
		const referenceValues = this.referenceYearData.map((f: any) => f.amountTotal);
		const compareValues = this.compareYearData.map((f: any) => f.amountTotal);

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "line",
			// The data for our dataset
			data: {
				labels,
				datasets: [
					{
						label: this.startYear, // Label shown above the graph
						borderColor: "#EFBB20", // Color of the line
						pointHitRadius: 2, // Size of the area where the point reacts to the mouse
						fill: true, // Filling (shadow) under the line
						tension: 0.3, // How "smooth" the line is. 0 for straight lines
						data: referenceValues,
					},
					{
						label: this.startYear - 1,
						borderColor: "#917216",
						pointHitRadius: 2,
						fill: true,
						tension: 0.3,
						data: compareValues,
					},
				],
			},
			// Configuration options go here
			options: {
				tooltips: {
					callbacks: {
						label: function (tooltipItem: any, data: any): any {
							var money = tooltipItem.yLabel;
							return `CHF: ${money
								.toFixed(2)
								.toString()
								.replace(/\B(?=(\d{3})+(?!\d))/g, "'")}`;
						},
					},
				},
			},
		});
		this.chart.update();
	}
}
